export const LocalStorageKey = 'hero-settings';

export const saveSettings = (settings: any) => {
  localStorage.setItem(LocalStorageKey, JSON.stringify(settings));
};

export const getSavedSettings = () => {
  return JSON.parse(localStorage.getItem(LocalStorageKey) || '{}');
};
